import React, { useState } from 'react';
import { EditIcon, TrashIcon,VerticalDotsIcon,ApplicationIcon } from '../../assets';
import { useNavigate } from 'react-router-dom';
import { bankcard_del } from '../../action/bancardAction';
import {useDispatch} from "react-redux";

const CardTableActions = (data) => {
    const [activeRow, setActiveRow] = useState(data.data.card_id);
    const [actions, setActions] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const ACTIONS = [
        {
            icon: ApplicationIcon,
            title: 'View Cars',
            action: () => navigate('/banks/'+data.data.bank_id+'/'+data.data.card_id)
        },
        {
            icon: ApplicationIcon,
            title: 'View Offers',
            action: () =>  console.log("hii") //navigate('/banks/'+data.data.bank_id+'/edit-upload-card/'+data.data.card_id)
        },
        {
            icon: EditIcon,
            title: 'Edit',
            action: () =>   navigate('/banks/'+data.data.bank_id+'/edit-upload-card/'+data.data.card_id)
        },
        {
            icon: TrashIcon,
            title: 'Delete',
            action: () => CardDelete(data.data.card_id)
        }
    ];

    const CardDelete = async(id) =>{
        console.log("in",id);
        var dtl ={
            'Id':id
        }
        var cat = await dispatch(bankcard_del(dtl));
        if (cat.success) {
           window.location.reload();
        }
    }


    return  <div className="pl-3 relative">
    <button className="py-3" 
      onMouseEnter={() => setActions(true)}
      onMouseLeave={() => setActions(false)}>
        <VerticalDotsIcon />
        {actions && (
            <div className="items-start top-8 -left-16 flex py-2 w-36 flex-col absolute bg-white z-40 shadow-xl border rounded-lg border-kb-light-gray text-kb-dark-gray">
                {ACTIONS.map((item) => (
                    <button
                        key={item.title}
                        className="px-4 py-2 w-full rounded-md flex gap-3 items-center hover:bg-kb-light-blue hover:text-kb-light-blue hover:bg-opacity-20"
                        onClick={item.action}
                    >
                        <item.icon />
                        <span>{item.title}</span>
                    </button>
                ))}
            </div>
        )}
    </button>
</div>;
};

export default CardTableActions;
